import { ReactElement, createContext, useContext } from "react";
import ServicesInfoPg, { ServicesLideresProps  } from "../services/getList";


export const PgListContext = createContext<ServicesLideresProps>(null);


export const EventsListProvider = ({children}: { children: ReactElement }) => {
  const context = ServicesInfoPg();
  return (
    <>
      <PgListContext.Provider value={context}>
        {children}
      </PgListContext.Provider>
    </>
  )
}

export const UseList = () => {
  const context = useContext(PgListContext);
  return context;
}
